import { Injectable } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { NEVER } from 'rxjs';

@Injectable()
export class CompatRedirectGuard implements CanActivate {
  initialRouteLoaded = false;
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): ReturnType<CanActivate['canActivate']> {
    if (!this.initialRouteLoaded) {
      this.initialRouteLoaded = true;
      return true;
    }
    if (window.location.hostname === 'localhost') {
      window.location.assign(`https://www.syd1.fln-dev.net${state.url}`);
    } else {
      window.location.assign(state.url);
    }
    return NEVER;
  }
}
